import React from 'react';
import { Link } from 'react-router-dom';

export const PropertyHero = () => {
 return (
    <div className='aboutHeroBg'>
        <div className='container'>
            <div className='aboutHeroTitle'>Explore Verified Properties Open for Interest & Bidding</div>
            <div className='aboutHeroSubTitle'>Browse real homes, plots, and spaces. Show interest only when you're ready.</div>
            <div className='heroBtnContainer'>
                 <div className='aboutHeroContact'><Link to="/contact"><button>Contact Us</button></Link></div>
                <div className='aboutHeroBrowse'><Link to="/properties"><button>Browse Properties</button></Link></div>

            </div>

        </div>

    </div>
  )
}
